module.exports = __webpack_public_path__ + "static/media/mastervisa.461021aa.png";